import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { SidesheetComponentOptions } from '../../shared/enums';

@Injectable({
    providedIn: 'root'
})
export class SidesheetUtilityService {

    private _isOpened = new Subject<boolean>();
    private _isClosed = new Subject<boolean>();
    isOpened$ = this._isOpened.asObservable();
    isClosed$ = this._isClosed.asObservable();

    isDisplayed = false;
    currentSidesheetComponent = SidesheetComponentOptions.None;
    isExternalCloseDisabled = false;

    constructor() { }

    closeSidesheet(): void {
        this._isOpened.next(false);
    }

    openSidesheet(sidesheetComponent: SidesheetComponentOptions, disableExternalClose = false): void {
        document.body.style.overflow = 'hidden';
        this.isDisplayed = true;
        this.currentSidesheetComponent = sidesheetComponent;
        this.isExternalCloseDisabled = disableExternalClose;
        this._isOpened.next(true);
    }

    clearCurrentSidesheetComponent(): void {
        this.currentSidesheetComponent = SidesheetComponentOptions.None;
        this.isExternalCloseDisabled = false;
    }

    setIsDisplayed(isDisplayed: boolean): void {
        this.isDisplayed = isDisplayed;
        if (!isDisplayed) {
            document.body.style.overflow = '';
            this._isClosed.next(true);
        }
    }

}
